import { Link } from 'react-router-dom';
import { getNewMovies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function NewMovies() {
  const newMovies = getNewMovies();

  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
              最新上线
            </h2>
            <p className="text-foreground-500 text-xs mt-1">刚出炉的热门新片，第一时间观看</p>
          </div>
          <Link
            to="/category/dongzuo"
            className="text-primary-500 text-xs font-medium hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            全部新片 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-5 stagger-children">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}